import React from "react";
import { DatePicker } from "antd";
import { Button } from "react-bootstrap";
import moment from "moment";

class ServiceInvoicesModal extends React.Component {
    dateFormat = "YYYY-MM-DD";

    constructor(props) {
        super(props);

        this.state = {
            date: moment()
        };

        this.handleChangeDate = this.handleChangeDate.bind(this);
        this.handleConfirm = this.handleConfirm.bind(this);
    }

    handleChangeDate(date) {
        this.setState({
            date
        });
    }

    handleConfirm() {
        this.props.handleExport();
        this.props.onCancel();
    }

    render() {
        return (
            <div>
                <div className="row justify-content-center pb-3">
                    <DatePicker
                        Format={this.dateFormat}
                        value={this.state.date}
                        onChange={this.handleChangeDate}
                        placeholder=""
                    />
                </div>
                <hr />

                <div className="text-right">
                    <Button className="ml-2" variant="success" onClick={this.handleConfirm}>
                        Ok
                    </Button>
                    <Button className="ml-2" variant="outline-primary" onClick={() => this.props.onCancel()}>
                        Cancel
                    </Button>
                </div>
            </div>
        );
    }
}

export default ServiceInvoicesModal;
